module.exports = __webpack_public_path__ + "fun_1.7c0eaf07d197788b66a0de369019755e.jpg";